
import { Component, Prop, Vue } from 'vue-property-decorator'
import CloseCross from '~/components/common/ctrls/CloseCrossCtrl.vue'

@Component({
  components: {
    CloseCross
  }
})
export default class ModalBasic extends Vue {
  @Prop({ type: Boolean, default: true }) showCloseCross: boolean
}
